export function getSearchScore(item, query) {
  const normalizedQuery = query.trim().toLowerCase();
  if (!normalizedQuery) return 0;
  const label = (item.label || "").toLowerCase();
  const searchText = (item.searchText || "").toLowerCase();
  const facets = (item.facets || []).map((facet) => facet.toLowerCase());
  if (label === normalizedQuery) return 1200;
  if (label.startsWith(normalizedQuery)) return 1000;
  if (label.includes(normalizedQuery)) return 850;
  if (facets.some((facet) => facet === normalizedQuery)) return 750;
  if (facets.some((facet) => facet.startsWith(normalizedQuery))) return 650;
  if (searchText.includes(normalizedQuery)) return 400;
  return 0;
}

export function getSearchResults(items, query) {
  return items
    .map((item) => ({ item, score: getSearchScore(item, query) }))
    .filter(({ score }) => score > 0)
    .sort((a, b) => b.score - a.score || a.item.label.localeCompare(b.item.label));
}
